export function excelToCartesian(excelCoord: string): [number, number] {
  const columnLetters = excelCoord.match(/[A-Z]+/);
  const rowNumbers = excelCoord.match(/\d+/);

  if (!columnLetters || !rowNumbers) {
    throw new Error('Invalid Excel coordinate format');
  }

  const column = columnLetters[0];
  const row = parseInt(rowNumbers[0], 10) - 1; // Convert to zero-based index

  // Convert column letters to a zero-based index
  let columnIndex = 0;
  for (let i = 0; i < column.length; i++) {
    columnIndex *= 26;
    columnIndex += column.charCodeAt(i) - 'A'.charCodeAt(0) + 1;
  }
  columnIndex -= 1; // Convert to zero-based index

  return [columnIndex, row];
}

export function cartesianToExcel(cartesianCoord: [number, number]): string {
  const [columnIndex, rowIndex] = cartesianCoord;

  // Convert zero-based column index to Excel column letters
  let columnLetters = '';
  let currentIndex = columnIndex + 1; // Convert to 1-based index
  while (currentIndex > 0) {
    currentIndex--; // Adjust for 0-based index
    columnLetters = String.fromCharCode('A'.charCodeAt(0) + (currentIndex % 26)) + columnLetters;
    currentIndex = Math.floor(currentIndex / 26);
  }

  // Convert zero-based row index to 1-based row number
  const rowNumber = (rowIndex + 1).toString();

  return columnLetters + rowNumber;
}

export function cartesianColumnToExcel(columnIndex: number): string {
  let columnLetters = '';
  let currentIndex = columnIndex + 1; // Convert to 1-based index

  while (currentIndex > 0) {
    currentIndex--; // Adjust for 0-based index
    columnLetters = String.fromCharCode('A'.charCodeAt(0) + (currentIndex % 26)) + columnLetters;
    currentIndex = Math.floor(currentIndex / 26);
  }

  return columnLetters;
}
